import React, { useContext } from 'react';

import { SpecialOffersPreloader } from '@sravni/react-ugc/lib/SpecialOffersPreloader';
import { useBoolean } from '@sravni/react-utils';

import type { ISpecialOffersContext } from '../../../../contexts/OffersPageQueryContext';
import { SpecialOffersContext } from '../../../../contexts/OffersPageQueryContext';
import { getComponentByTabType } from '../../../../helpers/getComponentByTabType';
import type { MessageParams } from '../../../../helpers/sendMessageToParentWindow';
import { useActiveTabType } from '../../../../store/hooks/offers';

export interface TabContentProps {
  preloaderItemsCount: number;
  maxDesktopVisibleItems: number;
  isWithLinkToAll: boolean;

  contentRef: React.RefObject<HTMLDivElement>;
  isMobile: boolean;
  sendMessageToParentWindow: (params: MessageParams) => void;
}

export const OneTabContent = React.memo<TabContentProps>(({ preloaderItemsCount, ...props }) => {
  const activeTabType = useActiveTabType();
  const { isPopup, isVerticalOnMobile } = useContext<ISpecialOffersContext>(SpecialOffersContext);

  const [showPreloader, setShowPreloader] = useBoolean();

  if (!activeTabType) return null;

  const Component = getComponentByTabType(activeTabType);

  const propsForComponent = {
    setShowPreloader,
    ...props,
  };

  return (
    <>
      {(showPreloader || !activeTabType) && (
        <SpecialOffersPreloader
          itemsCount={preloaderItemsCount}
          isPopup={isPopup}
          isVerticalOnMobile={isVerticalOnMobile}
        />
      )}
      <Component {...propsForComponent} />
    </>
  );
});
